import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioChange, MatRadioGroup } from '@angular/material/radio';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export type BaasRadioButtonGroupItem = { value: any; content?: any };

export interface IBaasRadioButtonGroupCellRendererParams<TData = any> extends ICellRendererParams {
    items?: BaasRadioButtonGroupItem[] | ((data: TData) => BaasRadioButtonGroupItem[]);
    disabled?: boolean | ((data: TData) => boolean);
}

// NOTE based on CUBA\Betalingsrechten, but tweaked
@Component({
    templateUrl: './baas-radio-button-group-cell-renderer.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatRadioButton, MatRadioGroup]
})
/** Render a group of radiobuttons with the possibility of editing. */
export class BaasRadioButtonGroupCellRenderer implements ICellRendererAngularComp {
    protected params: IBaasRadioButtonGroupCellRendererParams;
    protected items: BaasRadioButtonGroupItem[];
    protected disabled = false;
    protected value: any = null;

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: IBaasRadioButtonGroupCellRendererParams): void {
        this.params = params;
        this.value = params.value;
        this.items = this.#defineItems();
        this.disabled = this.#defineDisabled();
    }

    protected onValueChanged(event: MatRadioChange) {
        const columnId = this.params.column?.getColId();
        this.params.node.setDataValue(columnId!, event.value);
    }

    #defineDisabled(): boolean {
        const disabled = this.params.disabled;
        if (disabled != null) {
            if (disabled instanceof Function) {
                return disabled(this.params.data);
            } else {
                return disabled;
            }
        } else {
            return false;
        }
    }

    #defineItems(): BaasRadioButtonGroupItem[] {
        const items = this.params.items;
        if (!items) return [];
        if (items instanceof Function) {
            return items(this.params.data);
        } else {
            return items;
        }
    }
}
